const ITEMS_KEYS = ["industries.construction", "industries.engineering", "industries.energy", "industries.cabinetry", "industries.manufacturing", "industries.agriculture"];
import { useT } from "@/contexts/LanguageContext";

export default function IndustriesMarquee() {
  const { t } = useT();
  const items = ITEMS_KEYS.map((k) => t(k));
  const repeated = [...items, ...items, ...items];
  return (
    <section data-testid="industries-marquee" aria-label="Industries served" className="bg-[#070707] border-y border-white/10 py-10 overflow-hidden">
      <div className="flex gap-16 whitespace-nowrap animate-marquee">
        {repeated.map((it, i) => (
          <div key={`${it}-${i}`} className="flex items-center gap-16 shrink-0">
            <span className="font-display font-black text-5xl md:text-7xl tracking-tighter text-transparent" style={{ WebkitTextStroke: "1px rgba(255,255,255,0.4)" }}>
              {it}
            </span>
            <span className="text-[#D9633F] text-3xl">•</span>
          </div>
        ))}
      </div>
    </section>
  );
}
